import { Outlet } from 'react-router-dom'
import { useInitialPasswordSetupDeadline } from '@/features/auth/hooks/useInitialPasswordSetupDeadline'
import { PendingDeletionBanner } from '@/features/account-deletion/components/PendingDeletionBanner'
import Box from '@mui/material/Box'
import { ProviderShellNav } from '@/layouts/ProviderShellNav'
import { HomeFooter } from '@/features/home/components/HomeFooter'
import { homePageBg } from '@/features/home/styles/homeStyles'
import { useNotificationSocket } from '@/shared/hooks/useNotificationSocket'
import { EkycPromptHost } from '@/features/ekyc/components'

export function MainShellLayout() {
  useInitialPasswordSetupDeadline()
  useNotificationSocket()

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        bgcolor: homePageBg,
      }}
    >
      <ProviderShellNav />
      <PendingDeletionBanner />
      <Box
        component="main"
        sx={{ flex: 1, display: 'flex', flexDirection: 'column', minWidth: 0, overflowX: 'clip' }}
      >
        <Outlet />
      </Box>
      <HomeFooter />
      <EkycPromptHost />
    </Box>
  )
}
